import { Button } from "@mui/material";
import styled from "styled-components";
import { theme } from "theme";

export const HeaderBarView = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 42px 0px 14px 0px;
  border-bottom: 1px solid #d8d8d8;
  & > aside {
    display: flex;
    align-items: center;
    gap: 2rem;
  }
`;

export const ProfileButton = styled(Button)`
  font-family: "Inter" !important;
  font-size: 14px !important;
  text-transform: none !important;
  color: ${theme.primaryColor} !important;
`;

export const ProfilePopperView = styled.div`
  padding: 20px 12px;
  width: 240px;
  & > section {
    display: flex;
    flex-direction: column;
  }
  & > header {
    padding: 0 8px;
  }
`;

export const ProfileDropdownButton = styled(Button)`
  font-family: "Inter" !important;
  font-size: 14px !important;
  background: ${({ isSelected }) =>
    isSelected ? "#452D84" : "transparent"} !important;
  text-transform: none !important;
  color: ${({ isSelected }) => (isSelected ? "#fff" : "#4a4a4a")} !important;
  width: 100%;
  justify-content: flex-start !important;
`;

export const ActivateButton = styled(Button)`
  font-family: "Inter" !important;
  font-size: 14px !important;
  background: ${theme.accentColor} !important;
  text-transform: none !important;
  color: #fff !important;
  width: 100%;
`;
